import { Button, Card, CardActions, CardContent, LinearProgress, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { commons } from '../../commons';
import { formToObj, validateFormData } from '../../lib/validator';
import AuthService from '../../service/AuthService';
import { customStyles } from "../../styles/tableStyle"
import { changePasswordForm } from '../../schema/formSchema/forgotPassword';
import { FormGenerator } from '../../lib';
import { appMessages } from "../../constants/appMessages"

function PasswordChange(props) {
  const [loginData, setLoginData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    loadForm()
  }, []);

  const handleKeyDown = (event, key) => {
    if (event.key === 'Enter') {
      handleLogin(event, key);
    }
  };

  const loadForm = async () => {
    let loginSchemaData = [...changePasswordForm];
    if (props.type && props.type == "self") {
      let emailIndex = loginSchemaData.findIndex(item => item.key === "email");
      if (emailIndex > -1) {
        loginSchemaData[emailIndex].value = AuthService.getUserInfo().email
        loginSchemaData[emailIndex].disabled = true
      }
    }
    setLoginData(loginSchemaData);
  };


  const handleLogin = async (event) => {
    event.preventDefault();
    let loginContent = [...loginData];
    let validFormData = await validateFormData(loginContent);
    setLoginData(validFormData)
    let result = validFormData.find(item => {
      if (item.error.length) return item;
    });

    let passwordData = validFormData.find(item => item.key === "password");
    let confirmPasswordData = validFormData.findIndex(item => item.key === "confirmPassword")
    if (passwordData.value != validFormData[confirmPasswordData].value) {
      validFormData[confirmPasswordData].error = "Invalid password"
      setLoginData(validFormData)
      result = validFormData.find(item => {
        if (item.error.length) return item;
      });
    }

    if (!result) {
      setLoading(true)
      let params = await formToObj(validFormData);
      params.op = "setPassword"
      delete params.confirmPassword
      commons.getAPIRes(params, "POST", "user").then(userRes => {
        setLoading(false)
        if (userRes.status) {
          alert(appMessages.resetPasswordSucMsg)
          localStorage.clear();
          localStorage.setItem("login", false);
          localStorage.clear();
          window.location.href = '/login';
        }
        else {
          alert(appMessages.resetPasswordFailMsg)
        }
      });
    }
    else {

    }
  };

  const handleChange = e => {
    let formDataInput = [...loginData];
    formDataInput.find(item => {
      if (item.key === e.target.name) {
        item.value = item.type === "number" ? parseInt(e.target.value) : e.target.value;
      }
    });
    setLoginData(formDataInput)
  };


  return (
    <Card>
      {loading ? <LinearProgress /> : false}
      <CardContent style={{ justifyContent: 'center' }}>
        <FormGenerator
          formList={loginData}
          editMode={true}
          onChange={handleChange}
        />

      </CardContent>
      <CardActions style={{ justifyContent: 'end' }}>
        <Button onClick={props.closeDialog} disabled={loading} style={{ ...customStyles.submitBtn }} >Cancel </Button>
        <Button onClick={handleLogin} disabled={loading} style={{ ...customStyles.submitBtn }} > Submit </Button>
      </CardActions>
    </Card>
  );
}

export default PasswordChange;
